import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { SITE_DOMAIN, DEFAULT_SITE_ID } from "@/constants/site";

const SERVER_URL = process.env.NEXT_PUBLIC_SERVER_URL;

if (!SERVER_URL) {
  throw new Error("NEXT_PUBLIC_SERVER_URL 환경변수가 설정되지 않았습니다.");
}

export interface SiteItem {
  id: number;
  name: string;
  url: string;
  isActive: boolean;
  privacyPolicy: string | null;
}

export interface SiteListResponse {
  result: boolean;
  data: {
    total: number;
    list: SiteItem[];
  };
}

/** 사이트 목록 조회 */
const fetchSiteList = async (): Promise<SiteListResponse> => {
  const res = await axios.get<SiteListResponse>(`${SERVER_URL}site`);
  return res.data;
};

/** 사이트 목록 조회 Hook */
export const useGetSiteList = () => {
  return useQuery({
    queryKey: ["site", "list"],
    queryFn: fetchSiteList,
    staleTime: 1000 * 60 * 30,
  });
};

/** 현재 사이트 ID 조회 Hook (도메인 매칭) */
export const useGetSiteId = () => {
  const { data: sites, ...rest } = useGetSiteList();

  const siteId =
    sites?.data.list.find((site) => site.url.includes(SITE_DOMAIN))?.id ??
    DEFAULT_SITE_ID;

  return { siteId, ...rest };
};
